import React, {useState} from 'react'
export default function ABC(){
  const [ABC, setABC] = useState('')
  const [DEF, setDEF] = useState(false)
  const [GHI, setGHI] = useState('')
  const JKL = (e) => {
    e.preventDefault()
    setGHI('')
    var regExScan = new RegExp("^[A-Za-z0-9]{0,10}$")
    if (!regExScan.test(ABC)){
      setGHI('Input GHIor. Please check your input.')
    }else{
      setDEF(true)
    }
  }
  return (
    <>
    <div className='text-xs mb-2'>
    · a-z A-z 0-9<br/>
    · no special characters</div>
    <form className='flex-col flex text-xs' onSubmit={JKL}>
      <label className='text-left'>Username</label>
      <input type='text' placeholder='user123' className={`border w-[120px] ${GHI==''?'border-gray-950':'border-red-600'}`} onChange={e=> setABC(e.target.value)} maxlength={10} />
      { !( /^[A-Za-z0-9]{0,10}$/.test(ABC))?<span className='error-msg'>Special character is not allowed.</span>:''}
      <button className='primary-btn text-xs w-fit mt-1' disabled={!(ABC.length>0)}>Submit</button>
      {GHI==''&&DEF?<div className='text-xs'>You have successfully submited.</div>:<div className='error-msg'>{GHI}</div>}
    </form> 
    </>
  )
}